class SideNavigation
{
	constructor(el: HTMLElement)
	{
		const observer = new IntersectionObserver(entries =>
		{
			entries.forEach(entry =>
			{
				const id = entry.target.getAttribute('id');

				if (document.querySelector(`.content-sidebar__list a[href="#${id}"]`) != null)
				{
					if (entry.isIntersecting)
					{
						document.querySelectorAll(".content-sidebar__list .active").forEach(activeLink =>
						{
							activeLink.classList.remove('active');
						});

						document.querySelector(`.content-sidebar__list a[href="#${id}"]`)?.classList.add('active');

						return;
					}
				}
			});
		}, { rootMargin: "0% 0% -80% 0%" });

		document.querySelectorAll('.container[id]').forEach((section) =>
		{
			observer.observe(section);
		});
	}
}

document.querySelectorAll<HTMLElement>(".content-sidebar").forEach(el =>
{
	new SideNavigation(el);
});
